import React from "react";
import { useLang } from "../../context/LangContext";

export default function CaseStudies() {
  const { c } = useLang();
  const cs = c.cases;
  return (
    <section className="section">
      <div className="container-x">
        <div className="reveal" style={{ maxWidth: 720, marginBottom: "3.5rem" }}>
          <span className="eyebrow">{cs.eyebrow}</span>
          <h2 className="display" style={{ fontSize: "clamp(2.2rem,5vw,4rem)", margin: "1.2rem 0 1.2rem" }}>
            {cs.title.pre}<span className="italic-gold">{cs.title.em}</span>{cs.title.post}
          </h2>
          <p className="body-text" style={{ fontSize: "0.9rem" }}>{cs.intro}</p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))", gap: "1.5rem" }}>
          {cs.items.map((item, i) => (
            <div key={i} className="card reveal" style={{ padding: "2.4rem" }}>
              <span className="eyebrow" style={{ color: "var(--muted-2)", fontSize: "0.62rem" }}>{item.tag}</span>
              <h3 className="font-serif" style={{ fontSize: "1.7rem", margin: "1rem 0 1.6rem" }}>{item.title}</h3>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "0.8rem", marginBottom: "1.6rem" }}>
                {item.metrics.map(([v, l], j) => (
                  <div key={j} style={{ borderLeft: "1px solid var(--gold)", paddingLeft: "0.7rem" }}>
                    <div className="font-serif" style={{ fontSize: "1.5rem", color: "var(--gold)" }}>{v}</div>
                    <div style={{ fontSize: "0.62rem", letterSpacing: "0.08em", textTransform: "uppercase", color: "var(--muted-2)", marginTop: 4, lineHeight: 1.3 }}>{l}</div>
                  </div>
                ))}
              </div>
              <p className="body-text" style={{ fontSize: "0.88rem" }}>{item.desc}</p>
            </div>
          ))}
        </div>
        <p style={{ color: "var(--muted-2)", fontSize: "0.72rem", marginTop: "2.5rem", lineHeight: 1.6, maxWidth: 900 }}>{cs.disclaimer}</p>
      </div>
    </section>
  );
}
